export const generateSessionId = () => {
  const array = new Uint8Array(20)
  const hex = window.crypto.getRandomValues(array)
    .reduce((memo, i) => memo + (`0${i.toString(16)}`).slice(-2), '')
  return hex
}
